import {DEVICE_PIXEL_RATIO} from 'ol/has';

const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');

export const CanvasGradient = function(gradient, svg) {

	gradient.steps = gradient.steps.map((item,index) => {
		return `<stop offset="${item[1]}%" stop-color="${item[0]}"/>`
	})

	if(gradient.type === 'linear')
	{
		var gradient = (function () {
			var grad = context.createLinearGradient(
				gradient.linearVector.x1 * DEVICE_PIXEL_RATIO,
				gradient.linearVector.y1 * DEVICE_PIXEL_RATIO,
				gradient.linearVector.x2 * DEVICE_PIXEL_RATIO,
				gradient.linearVector.y2 * DEVICE_PIXEL_RATIO
			);
			grad.addColorStop(0, 'red');
			grad.addColorStop(1 / 6, 'orange');
			grad.addColorStop(2 / 6, 'yellow');
			grad.addColorStop(3 / 6, 'green');
			grad.addColorStop(4 / 6, 'aqua');
			grad.addColorStop(5 / 6, 'blue');
			grad.addColorStop(1, 'purple');
			return grad;
		})();
		return gradient;
	}
	else if(gradient.type === 'radial')
	{
		svg = svg.replaceAll(/fill="[^"]+"/g,'');
		svg = svg.replace(/(<svg[^>]+)>/,`$1>
			<radialGradient id="hapiGradiant">
				${gradient.steps.join('')}
			</radialGradient>
			<g fill="url(#hapiGradiant)">`);
		svg = svg.replace('</svg>',`</g></svg>`);
	}
	return svg;
}
export default CanvasGradient;